export default theme => ({
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
});
